import { useState } from "react";
import axios from "axios";
import { Sparkles, RefreshCw } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Kleiner KI-Regen-Button neben jedem Section-Header.
 *
 * Props:
 *   projectId: string
 *   section: "hero" | "about" | "services" | "contact"
 *   onRegenerated: (data) => void  // bekommt das frische Section-Objekt
 *   instructions?: string           // optionale Custom-Instructions
 *
 * Verhalten:
 *   - Klick → POST /api/projects/{id}/regenerate-section
 *   - Spinner während Request
 *   - Toast bei Erfolg + Übergabe an Parent
 *   - Toast bei Fehler
 */
export const SectionRegenButton = ({ projectId, section, onRegenerated, instructions = "" }) => {
  const [loading, setLoading] = useState(false);

  const handleClick = async (e) => {
    // Nicht das Section-Toggle (Header-Klick) auslösen
    e.stopPropagation();
    e.preventDefault();
    if (!projectId) return;
    setLoading(true);
    try {
      const r = await axios.post(
        `${API}/projects/${projectId}/regenerate-section`,
        { section, instructions },
        { withCredentials: true }
      );
      const data = r.data?.data;
      if (data === undefined || data === null) {
        toast.error("KI hat keinen Inhalt geliefert");
      } else {
        onRegenerated?.(data);
        toast.success(`Bereich „${section}" neu generiert`);
      }
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Section-Regen fehlgeschlagen");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={loading}
      title="Diesen Bereich mit KI neu generieren"
      className="flex items-center gap-1 px-2 py-1 rounded-sm text-[10px] font-bold uppercase tracking-wider bg-violet-500/10 hover:bg-violet-500/20 text-violet-700 transition-colors disabled:opacity-60"
      data-testid={`regen-section-${section}`}
    >
      {loading ? <RefreshCw size={10} className="animate-spin" /> : <Sparkles size={10} />}
      {loading ? "denkt..." : "KI"}
    </button>
  );
};
